// extracted by mini-css-extract-plugin
export default {"textarea_placeholder":"DeliveredMealReviewModal-module_textarea_placeholder_dOYAcxWZDO"};